import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ModalWizard from "../../../components/modal/ModalWizard";
import RouteCreator from "../../../core/RouteCreator";
import StockService from "../../../services/Stock/StockService";
import TagsService from "../../../services/Tags/TagsService";
import UserService from "../../../services/User/UserService";
import ToMyStockWizard from "./components/ToMyStockWizard";

const ScreeWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    display: flex;
    flex-wrap: nowrap;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
`;

const ToMyStock = () => {
    const { t } = useTranslation("screens");
    const history = useHistory();
    const {UserId} = UserService.getUserDetailsFromToken();

    const queryCylinderTags = async (tag) => {
        if (tag.length > 2) {
            const tags = await TagsService.lookupCompanyStockTag(tag);
            return tags.map((t) => t.id);
        }
        return [];
    };

    useEffect(() => {
        ModalWizard.show(
            ToMyStockWizard(t, queryCylinderTags),
            {
                onSubmit: async (values) => {
                    const result = await StockService.moveToInstallerStockAsync(values.cylinderTagId, UserId);
                    if (result && result.error)
                        ModalWizard.submitFailed(t(result.error.message));
                    else {
                        toast.success(
                            t("stockListing.toastNotification.moveToStockSuccess")
                        );
                        ModalWizard.hide();
                        setTimeout(() => {
                            history.push(RouteCreator.pwa.root());
                        }, 100);
                    }
                },
                onCancel: async () => {
                    ModalWizard.hidePrompt(()=>history.goBack());
                },
            },
            { pwa: true }
        );
    }, []);

    return <ScreeWrapper></ScreeWrapper>;
};

export default ToMyStock;
